module.exports = __webpack_public_path__ + "img/logo-sd-bc.8d9c8fe8.png";